// extracted by mini-css-extract-plugin
export var childrenContainer = "_4x-0";
export var virtualScrollArea = "_4x-1";